import { FC } from "react";
import cloud_rift from "../../img/cloud.jpg";
import fire_rift from "../../img/fire.jpg";
import hextech_rift from "../../img/hextech.jpg";
import mountain_rift from "../../img/mountain.jpg";
import normal_rift from "../../img/normal.jpg";
import ocean_rift from "../../img/ocean.jpg";
import baron_hunting from "../../img/barons/hunting.png";
import baron_seeing from "../../img/barons/seeing.png";
import baron_territorial from "../../img/barons/territorial.png";
import atakhan_n from "../../img/atakhan/atakhan_n.png";
import atakhan_s from "../../img/atakhan/atakhan_s.png";
import { useSnapshot } from "valtio";
import { uiState } from "@shared/states/uiStates";
import { useFrameAtakhan, useFrameBaronTerrain, useFrameDragon } from "@shared/Map/frame_hooks";
import { SVGImage } from "@shared/Map/objects/SVGImage";
import { RIFT_SIZE } from "@shared/Map/Map";

interface SVGRiftProps {}

const Rift: FC<SVGRiftProps> = () => {
	const uiSnap = useSnapshot(uiState);
	const dragonType = useFrameDragon(uiSnap.currentFrameIndex);
	const baronTerrainType = useFrameBaronTerrain(uiSnap.currentFrameIndex);
	const atakhan = useFrameAtakhan(uiSnap.currentFrameIndex);

	return (
		<>
			{/*TODO remove chemtech?*/}
			{(dragonType == "normal" || dragonType == "chemtech") && (
				<SVGImage href={normal_rift} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
			{dragonType == "fire" && (
				<SVGImage href={fire_rift} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
			{dragonType == "ocean" && (
				<SVGImage href={ocean_rift} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
			{dragonType == "wind" && (
				<SVGImage href={cloud_rift} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
			{dragonType == "mountain" && (
				<SVGImage href={mountain_rift} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
			{/*{dragonType == "chemtech" && (*/}
			{/*	<SVGImage href={chemtech_rift} width={RIFT_SIZE} height={RIFT_SIZE} />*/}
			{/*)}*/}
			{dragonType == "hextech" && (
				<SVGImage href={hextech_rift} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}

			{baronTerrainType === "hunting" && (
				<SVGImage href={baron_hunting} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
			{baronTerrainType === "territorial" && (
				<SVGImage href={baron_territorial} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
			{baronTerrainType === "seeing" && (
				<SVGImage href={baron_seeing} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}

			{atakhan?.position == "top" && (
				<SVGImage href={atakhan_n} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
			{atakhan?.position == "bottom" && (
				<SVGImage href={atakhan_s} width={RIFT_SIZE} height={RIFT_SIZE} />
			)}
		</>
	);
};

export default Rift;
